import React from 'react';
import PropTypes from 'prop-types';
import {
  Thumbnail2d,
  ThumbnailTypes,
  DefaultThumbnailSize,
  ThumbnailFormat
} from 'roblox-thumbnails';

function GameThumbnailContainer({ universeId }) {
  const thumbnail = (
    <Thumbnail2d
      type={ThumbnailTypes.gameIcon}
      size={DefaultThumbnailSize}
      targetId={universeId}
      imgClassName='game-card-thumb'
      format={ThumbnailFormat.jpeg}
    />
  );
  return (
    <div className='game-card-thumb-container'>
      <div className='game-card-thumb'>{thumbnail}</div>
    </div>
  );
}

GameThumbnailContainer.propTypes = {
  universeId: PropTypes.number.isRequired
};

export default GameThumbnailContainer;
